import { render } from "./OpsArticles.vue?vue&type=template&id=8318deb6&scoped=true"
import script from "./OpsArticles.vue?vue&type=script&lang=js"
export * from "./OpsArticles.vue?vue&type=script&lang=js"

import "./OpsArticles.vue?vue&type=style&index=0&id=8318deb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8318deb6"]])

export default __exports__